export const getSaleProducts = (page?: number, noLoading?: boolean) => ({
  type: "@saga/GET_SALE_PRODUCTS",
  payload: { page, noLoading },
});
